import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import Translator from "Languages/Utility/Translator";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import MuiButton from "Components/MuiButton/MuiButton";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { read } from "Helpers/LocalStorage";
import * as R from "ramda";
import SettingService from "Services/http/endpoints/setting/SettingService";
import StatusHandler from "Helpers/StatusHandler";
import showNotify from "Helpers/Notify";
import { useTranslation } from "react-i18next";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import * as Icons from "react-bootstrap-icons";

function FormTolid() {
  const { t } = useTranslation();
  const { settingTolidData } = useSelector((state) => ({
    settingTolidData: state.setting.settingTolidData,
  }));
  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [controls, setControls] = useSetState({
    bladeThickProfile: {
      type: "text",
      value: "",
      validation: null,
      endIcon: "millimeter",
    },
    bladeThickGalvanize: {
      type: "text",
      value: "",
      validation: null,
      endIcon: "millimeter",
    },
    wasteSizeProfile: {
      type: "text",
      value: "",
      validation: null,
      endIcon: "millimeter",
    },
    wasteSizeGalvanize: {
      type: "text",
      value: "",
      validation: null,
      endIcon: "millimeter",
    },
    glassFixer: {
      type: "text",
      value: "",
      validation: null,
    },
    bazsho: {
      type: "text",
      value: "",
      validation: null,
    },
    countMinScrewIron: {
      type: "text",
      value: "",
      validation: null,
      endIcon: "millimeter",
    },
    countBetweenScrowIron: {
      type: "text",
      value: "",
      validation: null,
      endIcon: "millimeter",
    },
    minOneCoveWater: {
      type: "text",
      value: "",
      validation: null,
      endIcon: "millimeter",
    },
    maxOneCoveWater: {
      type: "text",
      value: "",
      validation: null,
      endIcon: "millimeter",
    },
    minTwoCoveWater: {
      type: "text",
      value: "",
      validation: null,
      endIcon: "millimeter",
    },
    maxTwoCoveWater: {
      type: "text",
      value: "",
      validation: null,
      endIcon: "millimeter",
    },
    glassFontSize: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    optimization: {
      type: "checkbox",
      items: [],
    },
    locationCover: {
      type: "checkbox",
      items: [],
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
    setFormValid((prev) => ({ ...prev, [name]: true }));
  };

  const onChangeCheckbox_SelectAll = (e, name) => {
    setControls({
      [name]: {
        items: controls[name].items.map((inner) => {
          inner.value = true;
          return inner;
        }),
      },
    });
    setFormValid((prev) => ({ ...prev, [name]: true }));
  };

  const onFinish = async (e) => {
    e.preventDefault();
    const {
      bladeThickProfile,
      bladeThickGalvanize,
      wasteSizeProfile,
      wasteSizeGalvanize,
      glassFixer,
      bazsho,
      countMinScrewIron,
      countBetweenScrowIron,
      minOneCoveWater,
      maxOneCoveWater,
      minTwoCoveWater,
      maxTwoCoveWater,
      optimization,
      locationCover,
      glassFontSize,
    } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        let data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          MinOneCoveWater: +convertToEnglishNumber(minOneCoveWater.value),
          MaxOneCoveWater: +convertToEnglishNumber(maxOneCoveWater.value),
          MinTwoCoveWater: +convertToEnglishNumber(minTwoCoveWater.value),
          MaxTwoCoveWater: +convertToEnglishNumber(maxTwoCoveWater.value),
          ThickProfile: +convertToEnglishNumber(bladeThickProfile.value),
          ThickIron: +convertToEnglishNumber(bladeThickGalvanize.value),
          LenIsWeaste: +convertToEnglishNumber(wasteSizeProfile.value),
          LenIsWeasteIron: +convertToEnglishNumber(wasteSizeGalvanize.value),
          CountGlassFix: +convertToEnglishNumber(glassFixer.value),
          CountGlassPop: +convertToEnglishNumber(bazsho.value),
          CountMinScrewIron: +convertToEnglishNumber(countMinScrewIron.value),
          CountBetweenScrowIron: +convertToEnglishNumber(
            countBetweenScrowIron.value
          ),
          SizeFontGlass: +convertToEnglishNumber(glassFontSize.value),
        };
        optimization.items.map((item) => {
          data = {
            ...data,
            [item.key]: item.value,
          };
        });
        locationCover.items.map((item) => {
          data = {
            ...data,
            [item.key]: item.value,
          };
        });
        const response = await SettingService.postSettingTolid(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({
            text: t("Production_settings_successfully_completed"),
            customClass: "success",
          });
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    } else {
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  useEffect(() => {
    if (settingTolidData) {
      setControls({
        bladeThickProfile: { value: settingTolidData.ThickProfile },
      });
      setControls({
        bladeThickGalvanize: { value: settingTolidData.ThickIron },
      });
      setControls({
        wasteSizeProfile: { value: settingTolidData.LenIsWeaste },
      });
      setControls({
        wasteSizeGalvanize: { value: settingTolidData.LenIsWeasteIron },
      });
      setControls({ glassFixer: { value: settingTolidData.CountGlassFix } });
      setControls({ bazsho: { value: settingTolidData.CountGlassPop } });
      setControls({
        countMinScrewIron: { value: settingTolidData.CountMinScrewIron },
      });
      setControls({
        countBetweenScrowIron: {
          value: settingTolidData.CountBetweenScrowIron,
        },
      });
      setControls({
        minOneCoveWater: { value: settingTolidData.MinOneCoveWater },
      });
      setControls({
        maxOneCoveWater: { value: settingTolidData.MaxOneCoveWater },
      });
      setControls({
        minTwoCoveWater: { value: settingTolidData.MinTwoCoveWater },
      });
      setControls({
        maxTwoCoveWater: { value: settingTolidData.MinTwoCoveWater },
      });
      setControls({
        glassFontSize: { value: settingTolidData.SizeFontGlass },
      });
      const itemsOptimization = settingTolidData.Optimal.map((item) => {
        return {
          label: item.Key,
          value: item.Value,
          key: item.Key,
        };
      });
      setControls({ optimization: { items: itemsOptimization } });
      const itemsCover = settingTolidData.Cover.map((item) => {
        return {
          label: item.Key,
          value: item.Value,
          key: item.Key,
        };
      });
      setControls({ locationCover: { items: itemsCover } });
      const validation_data = {};
      Object.keys(controls)
        .filter((key) => controls[key].type !== "checkbox")
        .map((key) => {
          validation_data[key] =
            controls[key].value !== null || controls[key].value !== ""
              ? true
              : false;
        });
      setFormValid(validation_data);
    }
  }, [settingTolidData]);

  return (
    <Grid container>
      <Grid container spacing={2}>
        {Object.keys(controls).map((key, index) => {
          if (controls[key].type === "text") {
            return (
              <Grid item lg={2} md={3} sm={6} xs={12} key={key + index}>
                <Input
                  setValue={setValue.bind(this)}
                  name={key}
                  validation={controls[key].validation}
                  label={<Translator id={key} />}
                  value={controls[key].value}
                  type="text"
                  disabled={loading}
                  endIcon={controls[key].endIcon && (<Translator id={controls[key].endIcon} />)}
                />
              </Grid>
            );
          }
        })}
      </Grid>
      <Grid container spacing={2}>
        {Object.keys(controls).map((key, index) => {
          if (controls[key].type === "checkbox") {
            return (
              <Grid item md={6} sm={12} xs={12} key={key + index}>
                <MuiCheckBoxGroup
                  label={<Translator id={key} />}
                  name={key}
                  value={controls[key].value}
                  items={controls[key].items}
                  onChange={onChangeCheckbox}
                  className="horizontalCheckbox"
                  translate={true}
                  selectAllShow
                  onSelectAll={onChangeCheckbox_SelectAll}
                  disabled={loading}
                />
              </Grid>
            );
          }
        })}
      </Grid>
      <Grid item xs={12} className="d-flex justify-content-end my-4">
        <MuiButton
          loading={loading}
          color="primary"
          title={<Translator id="zakhireTanzimatTolid" />}
          innerIcon={<Icons.Floppy />}
          onClick={onFinish}
          fullwidthOnSm
        />
      </Grid>
    </Grid>
  );
}

export default FormTolid;
